import script from "./AddProduct.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddProduct.vue?vue&type=script&setup=true&lang=ts"

import "./AddProduct.vue?vue&type=style&index=0&id=786d2087&lang=css"

const __exports__ = script;

export default __exports__